import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["perfumePercentage", "perfumeFields", "blendSelection", "individualPerfumes"]

  connect() {
    // Set default value for new records (if select is empty)
    if (this.hasPerfumePercentageTarget) {
      if (!this.perfumePercentageTarget.value || this.perfumePercentageTarget.value === '') {
        // Check if this is a new record by looking at the form URL
        const form = this.perfumePercentageTarget.closest('form')
        const isNewRecord = form && form.action.includes('/new') || form.action.endsWith('/perfumed_candles')

        if (isNewRecord) {
          this.perfumePercentageTarget.value = '8'
        }
      }
    }

    // Initialize visibility based on current values
    this.togglePerfumeFields()

    // Initialize perfume type visibility
    if (this.hasIndividualPerfumesTarget && this.hasBlendSelectionTarget) {
      const individualRadio = document.getElementById('perfume_type_individual')
      const blendRadio = document.getElementById('perfume_type_blend')

      if (individualRadio && individualRadio.checked) {
        this.individualPerfumesTarget.style.display = 'block'
        this.blendSelectionTarget.style.display = 'none'
      } else if (blendRadio && blendRadio.checked) {
        this.individualPerfumesTarget.style.display = 'none'
        this.blendSelectionTarget.style.display = 'block'
      }
    }
  }

  togglePerfumeFields() {
    if (this.hasPerfumePercentageTarget && this.hasPerfumeFieldsTarget) {
      const hasValue = this.perfumePercentageTarget.value && this.perfumePercentageTarget.value !== ''

      // Check if there are already perfume fields rendered (edit mode)
      const hasPerfumes = this.perfumeFieldsTarget.querySelector('.nested-fields') !== null
      const hasBlend = this.hasBlendSelectionTarget && this.blendSelectionTarget.querySelector('select').value !== ''

      // Show if: has percentage value OR has existing perfumes OR has blend
      if (hasValue || hasPerfumes || hasBlend) {
        this.perfumeFieldsTarget.style.display = 'block'
      } else {
        this.perfumeFieldsTarget.style.display = 'none'
      }
    }
  }

  togglePerfumeType(event) {
    if (!this.hasBlendSelectionTarget || !this.hasIndividualPerfumesTarget) return

    const value = event.target.value

    if (value === 'blend') {
      this.blendSelectionTarget.style.display = 'block'
      this.individualPerfumesTarget.style.display = 'none'
    } else if (value === 'individual') {
      this.blendSelectionTarget.style.display = 'none'
      this.individualPerfumesTarget.style.display = 'block'
    }
  }
}

